<template>
  <div class="system-dic-container layout-padding">
    <el-card shadow="hover" class="layout-padding-auto">
      <div class="system-user-search mb15">
        <el-input
          v-model="queryData.key"
          size="small"
          placeholder="请输入"
          style="max-width: 180px"
        >
        </el-input>
        <el-button
          size="small"
          type="primary"
          class="ml10"
          @click="queryTableData"
        >
          <el-icon>
            <ele-Search />
          </el-icon>
          查询
        </el-button>
        <el-button
          size="small"
          type="success"
          class="ml10"
          @click="onOpenAddDic({})"
        >
          <el-icon>
            <ele-FolderAdd />
          </el-icon>
          新增
        </el-button>
      </div>
      <el-table :data="tableData" v-loading="loading" style="width: 100%">
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column prop="Picture" label="封面" show-overflow-tooltip>
          <template #default="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.Picture"
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="SwiperPicture" label="轮播图封面" show-overflow-tooltip>
          <template #default="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.SwiperPicture"
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="btitle"
          label="标题"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="bRemark"
          label="简介"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column label="操作" width="100">
          <template #default="scope">
            <el-button
              size="small"
              text
              type="text"
              @click="onOpenEditDic(scope.row)"
              >修改</el-button
            >
            <el-button
              size="small"
              text
              type="text"
              @click="onRowDel(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        class="mt15"
        :pager-count="5"
        :page-sizes="[10, 20, 30]"
        v-model:current-page="queryData.page"
        background
        v-model:page-size="queryData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <dicDialog
      ref="dicDialogRef"
      :uploadUrl="uploadUrl"
      @refresh="queryTableData()"
    ></dicDialog>
  </div>
</template>

<script>
import {
  QueryBlogList,
  DelBlogDetail,
} from "@/api/ArticleContent/ArticleContent";
import dicDialog from "./dialog.vue";
import * as Api from "../../api/api";
export default {
  components: { dicDialog },
  data() {
    return {
      uploadUrl: "",
      loading: false,
      tableData: [],
      total: 0,
      queryData: {
        page: 1,
        pageSize: 10,
        key: "",
      },
    };
  },
  methods: {
    onRowDel(row) {
      let that = this;
      this.$confirm("是否删除该数据？", "提示", {}).then(() => {
        that.HttpDelSysDic({ id: row.Id });
      });
    },
    onOpenAddDic(row) {
      this.$refs.dicDialogRef.openDialog(row, "add");
    },
    onOpenEditDic(row) {
      this.$refs.dicDialogRef.openDialog(row, "edit");
    },
    queryTableData() {
      let param = {
        page: this.queryData.page,
        intPageSize: this.queryData.pageSize,
        key: this.queryData.key,
        bcategory: 5,
      };
      this.HttpQueryBlogList(param);
    },
    onHandleSizeChange(val) {
      this.queryData.pageSize = val;
      this.queryTableData();
    },
    onHandleCurrentChange(val) {
      this.queryData.page = val;
      this.queryTableData();
    },
    //Http查询字典类型列表
    async HttpQueryBlogList(param) {
      this.loading = true;
      const res = await QueryBlogList(param);
      this.loading = false;
      if (res.data.status == 200) {
        let raw = res.data.response;
        this.total = raw.dataCount;
        this.tableData = raw.data;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    async HttpDelSysDic(param) {
      const response = await DelBlogDetail(param);
      let res = response.data || {};
      if (res.status == 200) {
        this.queryTableData();
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
  },

  mounted() {
    this.uploadUrl = Api.uploadUrl;
    this.queryTableData();
  },
};
</script>

<style scoped></style>